import  hindi  from './hindi/index';
import  marathi  from './marathi/index';
import  tamil  from './tamil/index';
import  gujarati  from './gujarati/index';
import  bengali  from './bengali/index';
import  english  from './india/index';
import  global  from './global/index';
import globalUS from './global-US/index'
import englishUS from './english-US/index'
import hindiUGC from './hindi-UGC/index'

const languageTranslationObject = {
     hindi,
     marathi,
     tamil,
     bengali,
     gujarati,
     english,
     global,
     globalUS,
     englishUS,
     hindiUGC
}
// content for odia is not ready
const allLanguage ={ ...Object.keys(languageTranslationObject)};


export {languageTranslationObject , allLanguage};
